// React
import React, { useState } from 'react';

// Redux
import { connect } from 'react-redux';
import { withRoomContext } from '../../../RoomContext';

// Prop types
import PropTypes from 'prop-types';

// Mui styles
import { withStyles, MuiThemeProvider, createTheme } from '@material-ui/core/styles';

// Mui core
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

// Icon
import FlipCameraAndroidIcon from '@material-ui/icons/FlipCameraAndroid';

// component

import DeviceSettings from '../Common/DeviceSettings';

const styles = (theme) =>
	({
		root : {
			zIndex : 99,
			width  : '100%',
			height : '100%'
		},
		dialogPaper : {
			padding                        : '1% 2%',
			minWidth                       : '350px',
			width                          : '30vw',
			[theme.breakpoints.down('lg')] : {
				width : '40vw'
			},
			[theme.breakpoints.down('md')] : {
				width : '50vw'
			},
			[theme.breakpoints.down('sm')] : {
				width : '70vw'
			},
			[theme.breakpoints.down('xs')] : {
				width : '90vw'
			}
		},
		content : {
			padding : '0 30px'
		},
		titleIcon : {
			width        : '3rem',
			height       : '3rem',
			marginBottom : '10%'
		},
		titleText : {
			color      : '#999898',
			fontSize   : '1rem',
			fontWeight : 'bold'
		},
		button : {
			width           : '4rem',
			height          : '4rem',
			borderRadius    : '4rem',
			boxShadow       : '2px 2px 4px #aaa',
			backgroundColor : '#8eba14',
			color           : 'white',
			'&:hover'       : {
				backgroundColor : '#f50057'
			}
		}
	});

const theme = createTheme({
	overrides : {
		MuiDialogTitle : {
			root : {
				backgroundColor : 'transparent',
				color           : '#999898',
				width           : '100%'
			}
		},
		MuiDialogContent : {
			root : {
				justifyContent : 'center',
				display        : 'flex',
				flexDirection  : 'column',
				alignItems     : 'center',
				overflowY      : 'none',
				padding        : '0.5rem 0'
			}
		},
		MuiDialogActions : {
			root : {
				justifyContent : 'space-around'
			}
		},
		MuiPaper : {
			rounded : {
				borderRadius : '0.5rem'
			}
		}
	}
});

const GuestSettingsDialog = ({
	classes,
	settingsDialogOpen,
	closeSettingsDialog
}) =>
{

	return (
		<MuiThemeProvider theme={theme}>
			<Dialog
				className={classes.root}
				open={settingsDialogOpen}
				onClose={closeSettingsDialog}
				classes={{
					paper : classes.dialogPaper
				}}
			>
				<DialogTitle id='form-dialog-title'>
					<Box
						display='flex'
						alignItems='center'
						flexDirection='column'
					>
						<Typography className={classes.titleText}>
							設定変更
						</Typography>
					</Box>
				</DialogTitle>

				<DialogContent>
					<Box className={classes.content}>
						<DeviceSettings
							volumeCheck={false}
							isHost={false}
						/>
					</Box>

				</DialogContent>

				<DialogActions>
					<Button
						className={classes.button}
						onClick={closeSettingsDialog}
						color='primary'
					>
						閉じる
					</Button>
				</DialogActions>
			</Dialog>
		</MuiThemeProvider>
	);
};

GuestSettingsDialog.propTypes =
{
	classes             : PropTypes.object.isRequired,
	settingsDialogOpen  : PropTypes.bool,
	closeSettingsDialog : PropTypes.func

};

const makeMapStateToProps = () =>
{
	const mapStateToProps = (state) =>
	{
		return {
		// 	room : state.room
		};

	};

	return mapStateToProps;
};

const mapDispatchToProps = (dispatch) =>
{
	return {
		// setChangePersonDialogOpen : (changePersonDialogOpen) =>
		// {
		// 	dispatch(settingsActions.setChangePersonDialogOpen(changePersonDialogOpen));
		// }
	};
};

export default withRoomContext(connect(
	makeMapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room === next.room
			);
		}
	}
)(withStyles(styles)(GuestSettingsDialog)));